<template>
	<div class="page-dashboard" :class="pageClass">
		<div class="page-bg" :style="pageStyle"></div>
		<div class="container">
			<component :is="painelDevice" />


		</div>
	</div>
</template>

<style>

</style>

<script>
// @ is an alias to /src

import PainelDesktop from '@/components/PainelDesktop.vue';
import PainelMobile from '@/components/PainelMobile.vue';



export default {
	name: 'home',
	components: {
		PainelDesktop,
		PainelMobile,

	},
	computed:{
		preferences(){
			return this.$store.getters.preferences;
		},
		user() {
			return this.$store.getters.user;
		},
		userIsAnonymous(){
			return this.$store.state.user.isAnonymous==true
		},
		painelDevice(){
			return this.$store.getters.isMobile?'PainelMobile':'PainelDesktop';
		},
		pageStyle(){
			let styles = []
			if(this.$store.getters.preferenceBg)
				styles.push({backgroundImage:'url('+this.$store.getters.preferenceBg+')'});
			return styles;
		},
		pageClass(){
			let classes = [
				'page-transparency-'+this.$store.getters.preferenceTransparency,
				'page-textColor-'+this.$store.getters.preferenceTextColor,
			];
			return classes;
		}
	},
	activated(){
		console.log('activated');
		bodyTheme(this.$store.getters.preferenceTema);
		if(this.$store.state.userDataFetched) return
		this.$store.dispatch('startLoading');

		var q1 = this.$store.dispatch('queryCategories');
		var q2 = this.$store.dispatch('queryLinks');
		var q3 = this.$store.dispatch('queryTasks');
		var q4 = this.$store.dispatch('queryTextlinks');

		Promise.all([q1, q2, q3, q4]).then(()=>{
			this.$store.dispatch('stopLoading');
			this.$store.state.userDataFetched = true;
		})

		if(this.$store.state.sharedCategoryId){
			console.log('home activated, SharedCategoryId: ',this.$store.state.sharedCategoryId);
			this.$router.push({path:'/add-shared-category'})
		} else if(this.$store.state.sharedDashboardId){
			console.log('home activated, SharedDashboardId: ',this.$store.state.sharedDashboardId);
			this.$router.push({path:'/add-shared-dashboard'})
		} else if(this.userIsAnonymous){
			this.$router.push({path:'/exemplo'})
		}
	},
	deactivated(){
		bodyTheme('');
	},

}





</script>